// extracted by mini-css-extract-plugin
export default {"autocomplete":"src-UI-Autocomplete--autocomplete","list":"src-UI-Autocomplete--list","item":"src-UI-Autocomplete--item","item_selected":"src-UI-Autocomplete--item_selected"};